export const calculateEmptyFields = (
  value: Partial<Address> | undefined,
  entityName: string,
): string[] => {
  const res: string[] = [];
  if (value?.street === undefined) {
    res.push(`${entityName}AddressStreet`);
  }
  if (value?.city === undefined) {
    res.push(`${entityName}AddressCity`);
  }
  if (value?.postalCode === undefined) {
    res.push(`${entityName}AddressPostalCode`);
  }
  return res;
};

export const calculateFieldsToLoad = (
  value: Partial<Address> | undefined,
  entityName: string,
): string[] => {
  const res: string[] = [];
  if (value?.street !== undefined) {
    res.push(`${entityName}AddressStreet`);
  }
  if (value?.unit !== undefined) {
    res.push(`${entityName}AddressUnit`);
  }
  if (value?.city !== undefined) {
    res.push(`${entityName}AddressCity`);
  }
  if (value?.region !== undefined) {
    res.push(`${entityName}AddressRegion`);
  }
  if (value?.postalCode !== undefined) {
    res.push(`${entityName}AddressPostalCode`);
  }
  return res;
};
